import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { buildLinkHtml } from '../../utils/richEmailEditorUtils';
import MergeFieldInput from './MergeFieldInput';

const LinkInsertPopover = ({ isOpen, onClose, onInsert, selectedText = '', token }) => {
  const [url, setUrl] = useState('');
  const [text, setText] = useState('');
  const [openInNewTab, setOpenInNewTab] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setUrl('');
      setText(selectedText || '');
      setOpenInNewTab(true);
    }
  }, [isOpen, selectedText]);

  const handleApply = () => {
    if (!url.trim()) return;
    onInsert?.(buildLinkHtml({ url: url.trim(), text: text.trim() || url.trim(), openInNewTab }));
    onClose?.();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent className="max-w-md" data-testid="link-insert-modal">
        <DialogHeader>
          <DialogTitle>Add Link</DialogTitle>
          <DialogDescription className="sr-only">
            Insert a hyperlink into the email body.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label htmlFor="link-url">URL</Label>
            <MergeFieldInput
              id="link-url"
              data-testid="link-url-input"
              value={url}
              onValueChange={setUrl}
              token={token}
              placeholder="https:// or {{reset_link}}"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="link-text">Display text (optional)</Label>
            <Input
              id="link-text"
              data-testid="link-text-input"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Click here"
            />
          </div>
          <div className="flex items-center justify-between">
            <Label htmlFor="link-new-tab">Open in new tab</Label>
            <Switch
              id="link-new-tab"
              checked={openInNewTab}
              onCheckedChange={setOpenInNewTab}
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose}>Cancel</Button>
            <Button
              onClick={handleApply}
              disabled={!url.trim()}
              className="bg-blue-600 hover:bg-blue-700 text-white"
              data-testid="link-insert-apply"
            >
              Insert link
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LinkInsertPopover;
